import React, { Component } from 'react';
import Currency from '../../../commonModules/Currency';
import PopUp from '../../../commonModules/interface/PopUp';
import { Button, Table, TableBody, TableRow, TableCell, Box, Typography, TableHead, CardHeader } from '@material-ui/core';
import { TableLayout } from '../Stock/containers/Layout';
import FacturePreview from '../../AdminDashboard/Society/FacturePreview';

const translate = {
    "mm": "Mobile Money",
    "MM": "Mobile Money",
}
class Receipt extends Component {
    state = { 

    }
    render() {
        const { userInfo, payment} = this.props;
        console.log('====================================');
        console.log(this.props);
        console.log('====================================');
        
        return (
            <PopUp
                close={this.props.close}
                title="Reçu paiement"
            >                
                <Button 
                    variant="contained"
                    color="secondary"
                    className="btn btn-warning" 
                    onClick={() => window.print()}
                >
                    Imprimer
                </Button>
                <FacturePreview>
                    <Box m={1} style={{ float: "right", width: "250px"}}>
                        <Typography variant="body1"><b>{userInfo.clientName}</b></Typography>
                        <Typography variant="body1">Box n° {userInfo.idBox}</Typography>
                        <address>
                            <Typography variant="body2">{userInfo.phone}</Typography>
                            <Typography variant="body2">{userInfo.address}</Typography>
                        </address>

                    </Box>
                    <div style={{clear: "both"}}></div>

                    <Box p={2} />
                    <Box p={2}>

                        <Typography variant="h4" align="center">
                            Récapitulatif de paiement
                        </Typography>
                        {/* <Box >
                            <CardHeader
                                disableTypography	
                                title={<Typography variant="h4" align="center">Récapitulatif de paiement</Typography>}
                                // avatar={<PersonRounded />}
                            />
                        </Box> */}
                        {/* <p>Date du paiement: {new Date(payment.timePayment).toLocaleDateString("fr-FR")} </p>
                        <p>Mode de paiement: {translate[payment.typePayment] || payment.typePayment} </p> */}
                        <hr/>

                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Montant</TableCell>
                                    <TableCell>Mode de Paiement</TableCell>
                                    {/* <TableCell></TableCell>
                                    <TableCell></TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{new Date(payment.timePayment).toLocaleDateString("fr-FR")}</TableCell>
                                    <TableCell><b><Currency value={payment.money} /></b> </TableCell>
                                    <TableCell>{translate[payment.typePayment] || payment.typePayment}</TableCell>
                                    {/* <TableCell></TableCell>
                                    <TableCell></TableCell> */}
                                </TableRow>
                            </TableBody>
                        </TableLayout>
                    </Box>
                </FacturePreview>
            </PopUp>
        );
    }
}

export default Receipt;